/*
 * @Author: qiaoshiteng
 * @Date: 2023-06-14 11:12:48
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-03-21 11:22:04
 * @Description:
 */
// @/api/model/user.js

import config from "@/config";
import http from "@/utils/request";

export default {
	cooperationTaskList: {
		url: `${config.MAIN_URL}/api/v1/cooperationTask/queryByPage`,
		name: "协同标绘分页查询",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	messageView: {
		url: `${config.MAIN_URL}/api/v1/cooperationTask/messageView`,
		name: "查看任务",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	historyMessage: {
		url: `${config.MAIN_URL}/api/v1/cooperationTask/historyMessage`,
		name: "历史消息",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	replay: {
		url: `${config.MAIN_URL}/api/v1/cooperationTask/replay`,
		name: "历史消息",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	listProcessingTask: {
		url: `${config.MAIN_URL}/api/v1/cooperationTask/listProcessingTask`,
		name: "协同任务下拉",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	queryTaskApplication: {
		url: `${config.MAIN_URL}/api/v1/cooperationTask/queryTaskApplication`,
		name: "协同标绘申请加入任务查询",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	listMapMessageOrderByUser: {
		url: `${config.MAIN_URL}/api/v1/cooperationTask/listMapMessageOrderByUser`,
		name: "协同任务按人展示地图信息",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},

	addTask: {
		url: `${config.MAIN_URL}/api/v1/cooperationTask/addTask`,
		name: "协同标绘新增",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},
	addTasktwo: {
		url: `${config.MAIN_URL}/api/v2/cooperationTask/addTask`,
		name: "协同标绘新增",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},

	deleteTask: {
		url: `${config.MAIN_URL}/api/v1/cooperationTask/deleteTask`,
		name: '协同标绘删除',
		delete: async function (params) {
			return await http.delete(this.url + params);
		},
	},

	updateTask: {
		url: `${config.MAIN_URL}/api/v1/cooperationTask/updateTask`,
		name: "协同标绘修改",
		put: async function (params) {
			return await http.put(this.url , params);
		},
	},
	updateTaskStatus: {
		url: `${config.MAIN_URL}/api/v1/cooperationTask/updateTaskStatus`,
		name: "协同标绘任务状态修改",
		put: async function (params) {
			return await http.put(this.url , params);
		},
	},
	checkJoinApplication: {
		url: `${config.MAIN_URL}/api/v1/cooperationTask/checkJoinApplication`,
		name: "协同标绘加入任务审核",
		put: async function (params) {
			return await http.put(this.url , params);
		},
	},
	autoAnalyse: {
		url: `${config.MAIN_URL}/api/v1/cooperationTask/autoAnalyse`,
		name: "协同标绘自动解析状态",
		put: async function (params) {
			return await http.put(this.url , params);
		},
	},

};
